import produce from 'immer';

// TYPES
import { Types, AtualizarMensagemErro } from './types';
import { ReducerAction } from '../../../../../../types';

export const INITIAL_STATE: AtualizarMensagemErro = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): AtualizarMensagemErro {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_MENSAGEM_ERRO_REQUEST: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.ATUALIZAR_MENSAGEM_ERRO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.ATUALIZAR_MENSAGEM_ERRO_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ATUALIZAR_MENSAGEM_ERRO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
	});
}
